import { useState } from "react";
import { Outlet } from "react-router-dom";

import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";

function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] =
    useState(false);

  return (
    <div className="min-h-screen bg-black text-white">

      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <AdminSidebar
          setSidebarOpen={setSidebarOpen}
        />
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`
        fixed
        top-0
        left-0
        z-50
        h-screen
        w-72
        bg-[#0b0b0b]
        transition-transform
        duration-300
        lg:hidden
        ${
          sidebarOpen
            ? "translate-x-0"
            : "-translate-x-full"
        }
      `}
      >
        <AdminSidebar
          setSidebarOpen={setSidebarOpen}
        />
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="
          fixed
          inset-0
          bg-black/70
          z-40
          lg:hidden
          "
          onClick={() =>
            setSidebarOpen(false)
          }
        />
      )}

      {/* Main Content */}
      <div
        className="
        lg:ml-72
        min-w-0
        "
      >
        <AdminNavbar
          setSidebarOpen={setSidebarOpen}
        />

        <div
          className="
          p-4
          md:p-8
          overflow-x-hidden
          "
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;